// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { useEffect, useMemo } from 'react';
import { useCurrentScenarioData } from '../../../state/hooks/ScenarioHooks';
import { useInitializeGanttTwingraphQueries, useTechnicalPolicies } from '../../../state/wizard/WizardHooks';
import { initTasks } from './helper';

export const useGantt = () => {
  const scenarioData = useCurrentScenarioData();
  const datasetId = scenarioData.datasetList[0];
  const getInitialQueries = useInitializeGanttTwingraphQueries(scenarioData);
  useEffect(() => {
    if (datasetId) getInitialQueries(datasetId);
  }, [datasetId, getInitialQueries]);
  const technicalPolicyData = useTechnicalPolicies(scenarioData.id);
  const tasks = useMemo(() => {
    if (technicalPolicyData) return initTasks(technicalPolicyData);
    else return null;
  }, [technicalPolicyData]);
  return { tasks };
};
